<div class="page-content d-flex justify-content-center align-items-center">
	<div class="tile">
		<div class="tile-header d-flex justify-content-center">
			<a class="logo">
				<span>PRIS</span>
			</a>
		</div>

		<div class="tile-body">
			<div class="alert info">
				<p>
					Deze applicatie maakt gebruikt van nieuwe technieken welke <strong>niet</strong> door uw huidige browser worden ondersteund.
				</p>
				<p>
					Om volledig gebruik te kunnen maken van de functionaliteiten van de applicatie adviseren wij om gebruik te maken
					van <strong>Google Chrome</strong>, <strong>Firefox</strong> of <strong>MS Edge</strong>
				</p>
			</div>
		</div>
	</div>
</div>